var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8710_17064)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 4.5L3.75 4.5C2.92157 4.5 2.25 5.17157 2.25 6L2.25 18C2.25 18.8284 2.92157 19.5 3.75 19.5L20.25 19.5C21.0784 19.5 21.75 18.8284 21.75 18L21.75 6C21.75 5.17157 21.0784 4.5 20.25 4.5ZM3.75 2.25L20.25 2.25C22.3211 2.25 24 3.92893 24 6L24 18C24 20.0711 22.3211 21.75 20.25 21.75L3.75 21.75C1.67893 21.75 -7.94626e-07 20.0711 -8.85155e-07 18L-2.53295e-07 6C-3.43824e-07 3.92893 1.67893 2.25 3.75 2.25Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 21L7.875 3H9.375L9.375 21H7.875Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11.625L0 11.625L0 10.125L24 10.125V11.625Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91969 7.91098C5.33619 7.44993 6.04758 7.41381 6.50864 7.83031L12.7016 13.4248C12.8673 13.5745 12.7372 13.8482 12.5164 13.8141L11.5087 13.6586C11.3454 13.6334 11.2115 13.7869 11.2587 13.9452L11.5221 14.8292C11.587 15.0472 11.3244 15.2128 11.1556 15.0604L5.00036 9.49992C4.53931 9.08342 4.50319 8.37203 4.91969 7.91098Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03058 13.9259C4.80954 13.9738 4.66396 13.7022 4.82618 13.5447L10.7879 7.75311C11.2336 7.32017 11.9458 7.33049 12.3788 7.77614C12.8117 8.2218 12.8014 8.93403 12.3557 9.36696L6.32519 15.2253C6.16902 15.377 5.90991 15.2406 5.94663 15.026L6.12115 14.006C6.14803 13.8489 6.00754 13.7144 5.85176 13.7481L5.03058 13.9259Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8710_17064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSetting);
export default __webpack_public_path__ + "static/media/gift-setting.21811f50961834bc6210ff01f85946d7.svg";
export { ForwardRef as ReactComponent };